<template>
  <AppDrawer
    v-model="open"
    :title="t('promo.rebate.rulesTitle')"
    padded
    body-padding="0px 14px 48px"
    @back="emit('close')"
  >
    <div class="sub-body">
      <div class="section" style="margin-top: 14px">
        <div class="act-block-t">{{ t('promo.rebate.ruleRatioTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.rebate.ruleRatio2')"></li>
        </ul>
      </div>
      <div class="section">
        <div class="act-block-t">{{ t('promo.rebate.ruleDistributeTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.rebate.ruleDistribute3')"></li>
        </ul>
      </div>
      <div class="section">
        <div class="act-block-t">{{ t('promo.rebate.ruleClaimTitle') }}</div>
        <ul class="act-terms">
          <li v-html="t('promo.rebate.ruleClaim2')"></li>
          <li
            v-if="needWagering"
            v-html="t('promo.rebate.ruleClaim3', { n: wageringMultiple })"
          ></li>
          <li v-else v-html="t('promo.rebate.ruleClaimFree')"></li>
          <li v-html="t('promo.rebate.ruleClaim4')"></li>
        </ul>
      </div>
      <div style="height: 20px"></div>
    </div>
  </AppDrawer>
</template>

<script setup lang="ts">
import AppDrawer from '~/components/AppDrawer.vue'

const { t } = useI18n()

const props = defineProps<{
  modelValue: boolean
  rewardTarget?: 'available' | 'bonus'
  wageringMultiple?: string
}>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  close: []
}>()

/** wagering_multiple：免码为 "0"，需打码如 "5"（领取金额 × 5） */
const wageringMultiple = computed(() => {
  const n = Number(props.wageringMultiple)
  return Number.isFinite(n) && n > 0 ? n : 0
})

/** 倍数为 0 一律免码；倍数大于 0 时再看 reward_target（available=免码，bonus=需打码） */
const needWagering = computed(
  () => wageringMultiple.value > 0 && props.rewardTarget !== 'available',
)

const open = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<style scoped lang="scss">
.section {
  margin-top: 18px;
}

.act-block-t {
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  margin: 0 2px 10px;
  padding-left: 9px;
  border-left: 3px solid var(--primary);
}

.act-terms {
  margin: 0;
  padding: 0 2px;
  list-style: none;

  li {
    position: relative;
    padding: 0 0 9px 15px;
    font-size: 12.5px;
    line-height: 1.6;
    color: var(--muted);
  }

  li::before {
    content: '';
    position: absolute;
    left: 2px;
    top: 8px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--primary);
  }
}
</style>
